/* Cash Money — micro-interactions فقط. مفيش مكتبات، مفيش حاجة بتتحرك باستمرار.

   مبدأ أساسي: المحتوى ظاهر ومفتوح بالافتراض.
   الجافاسكريبت بيضيف التحسين بس — لو وقع، الموقع يفضل مقروء بالكامل. */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = !reduce && ('IntersectionObserver' in window);

  /* ------------------------------------------------------------------
     ثيم Horizon بيقفل التمرير على html/body وبيخلي السكرول جوّا .page-wrapper
     (base.css: html:has(.page-wrapper){height:100dvh;overflow:hidden}).
     ------------------------------------------------------------------ */
  function getScroller() {
    var wrap = document.querySelector('.page-wrapper');
    if (wrap && wrap.scrollHeight > wrap.clientHeight + 4) return wrap;
    return null;
  }

  function scrollTopOf(el) {
    if (el) return el.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  /* --- 1) الهيدر compact بعد السكرول --- */
  var scroller, bound = null, ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      document.body.classList.toggle('cm-scrolled', scrollTopOf(scroller) > 40);
      ticking = false;
    });
  }

  function bindScroll() {
    scroller = getScroller();
    var target = scroller || window;
    if (target === bound) return;
    if (bound) bound.removeEventListener('scroll', onScroll);
    bound = target;
    bound.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- 2) ظهور هادئ للعناصر مرة واحدة --- */
  var observer = null;

  function showAll() {
    var n = document.querySelectorAll('.cm-reveal:not(.cm-in)');
    for (var i = 0; i < n.length; i++) n[i].classList.add('cm-in');
  }

  function observe(root) {
    if (!observer) return;
    var n = (root || document).querySelectorAll('.cm-reveal:not(.cm-in)');
    for (var i = 0; i < n.length; i++) observer.observe(n[i]);
  }

  function initReveal() {
    if (!canAnimate) { showAll(); return; }

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-cm-delay') || '0', 10);
        setTimeout(function () { el.classList.add('cm-in'); }, delay);
        observer.unobserve(el);
      });
    }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    html.classList.add('cm-ready');
    observe(document);

    /* شبكة أمان: لو المراقب مااشتغلش نظهّر كل حاجة */
    setTimeout(function () {
      if (document.querySelectorAll('.cm-reveal.cm-in').length === 0) showAll();
    }, 2500);
  }

  /* --- 3) أعمدة الفوتر تطوى على الموبايل بس ---
     الـ HTML بيتكتب open دايمًا، فلو الجافاسكريبت وقع الروابط كلها ظاهرة. */
  var mqSmall = window.matchMedia('(max-width: 640px)');

  function footerAccordion() {
    var groups = document.querySelectorAll('[data-cm-collapsible]');
    for (var i = 0; i < groups.length; i++) groups[i].open = !mqSmall.matches;
  }

  function boot() {
    html.classList.remove('no-js');
    bindScroll();
    initReveal();
    footerAccordion();
    setTimeout(bindScroll, 600);
    setTimeout(bindScroll, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var rt;
  window.addEventListener('resize', function () {
    bindScroll();
    clearTimeout(rt);
    rt = setTimeout(footerAccordion, 200);
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
    if (!canAnimate) showAll();
    bindScroll();
    footerAccordion();
  });
})();
